import React from "react";
import { Auth0Provider, AppState } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import { env } from "../utils/env";
import { appUrls } from "../utils/use-get-page-url";

// Configures the Auth0 React SDK with localStorage caching and refresh-token
// rotation so access tokens are renewed silently without relying on
// iframe/third-party-cookie based session checks (which modern browsers block).
export const Auth0ProviderWithNavigate: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const navigate = useNavigate();

  const onRedirectCallback = (appState?: AppState) => {
    navigate(appState?.returnTo || appUrls.home);
  };

  return (
    <Auth0Provider
      domain={env.AUTH0_DOMAIN}
      clientId={env.AUTH0_CLIENT_ID}
      authorizationParams={{
        audience: env.AUTH0_CLASSIFIER_API_AUDIENCE,
        redirect_uri: window.location.origin + appUrls.callback,
        scope: "openid profile email",
      }}
      cacheLocation="localstorage"
      useRefreshTokens
      useRefreshTokensFallback
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};
